<template>
    <div class="warp" :style ='{height:(this.$store.state.windowHeight-this.$store.state.topBlockHeight-70)+"px"}'>
       <div class="content common-space-between">
           <div class="left-block hengblock">
                <!--平台收入-->
                <div>
                    <Income></Income>
                    <ChartCurveIM></ChartCurveIM>
                    <ChartRingIM></ChartRingIM> 
                </div>
           </div>
           <div class="right-block hengblock">
                <!--平台支出-->
                <div>
                    <Expend></Expend>
                    <ChartCurex></ChartCurex>
                    <ChartRingex></ChartRingex>    
                </div>
           </div> 
       </div>
    </div>
</template>
<script>

import Income        from './common-module/block-left/block-income.vue'
import ChartCurveIM  from './common-module/block-left/block-chartIM.vue'
import ChartRingIM   from './common-module/block-left/block-chartRing.vue'
import Expend        from './common-module/block-right/block-expend.vue'
import ChartCurex    from './common-module/block-right/block-chartex.vue'
import ChartRingex   from './common-module/block-right/block-chartRing.vue'
export default {
    components:{
        Income:Income,
        ChartCurveIM:ChartCurveIM,
        ChartRingIM:ChartRingIM,
        Expend:Expend,
        ChartCurex:ChartCurex,
        ChartRingex:ChartRingex
    },
    data () {
        return {
           show:true
        }
    },
    created(){
       
    },
    methods:{
        
    },
}
</script>
<style lang="scss" scoped>
    .warp{
       overflow-y: auto;
       padding:0px;
       box-sizing: border-box;
       border-radius: 10px;
       background-size: cover;
       background-image: url("./../../../../assets/custom-image/indexBack.svg");
       background-repeat: no-repeat;  
    }
    .hengblock{
        width: calc(50% - 10px);
    }
    .common-bottom{
        margin-bottom: 20px;
    }
</style>
